import { render, staticRenderFns } from "./BundleScreen.vue?vue&type=template&id=1af0fe52&scoped=true&"
import script from "./BundleScreen.vue?vue&type=script&lang=js&"
export * from "./BundleScreen.vue?vue&type=script&lang=js&"
import style0 from "./BundleScreen.vue?vue&type=style&index=0&id=1af0fe52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af0fe52",
  null
  
)

export default component.exports